// extracted by mini-css-extract-plugin
export default {"segment":"Segment_segment__sr0n+","avatar":"Segment_avatar__uTVlX","full":"Segment_full__v2bNE"};